"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsSubscriptions = PaymentsSubscriptions;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const elements_1 = require("@src/components/elements");
const FormattedDate_1 = require("@src/components/modules/FormattedDate");
const react_intl_1 = require("react-intl");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const types_1 = require("@src/types");
const icons_1 = require("@ant-design/icons");
const styled_components_1 = __importDefault(require("styled-components"));
const premium_subscription_1 = require("@src/helpers/premium-subscription");
const CancelSubscriptionModal_1 = __importDefault(require("./CancelSubscriptionModal"));
const Table_1 = require("@src/components/elements/Table");
const dayjs_1 = __importDefault(require("dayjs"));
const SubscriptionStatusTag = (0, styled_components_1.default)(elements_1.Tag) `
	display: inline-flex;
	align-items: center;
	margin: auto;
`;
const CustomTag = (0, styled_components_1.default)(elements_1.Tag) `
	width: fit-content;
	margin: auto;
`;
function PaymentsSubscriptions() {
    const intl = (0, react_intl_1.useIntl)();
    const [selectedSubscriptionIdToCancel, setSelectedSubscriptionIdToCancel] = react_1.default.useState(null);
    const { companyInfo: { companyPaymentSubscriptions }, } = (0, admin_context_1.useAdminContextValue)();
    const companyPaymentSubscriptionsSortedByCreatedAt = companyPaymentSubscriptions
        ? [...companyPaymentSubscriptions].sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1)
        : [];
    const activeSubscriptions = (companyPaymentSubscriptionsSortedByCreatedAt === null || companyPaymentSubscriptionsSortedByCreatedAt === void 0 ? void 0 : companyPaymentSubscriptionsSortedByCreatedAt.filter(subscription => {
        return (0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)([
            subscription,
        ]);
    })) || [];
    const expiredSubscriptions = (companyPaymentSubscriptionsSortedByCreatedAt === null || companyPaymentSubscriptionsSortedByCreatedAt === void 0 ? void 0 : companyPaymentSubscriptionsSortedByCreatedAt.filter(subscription => {
        return !(0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)([
            subscription,
        ]);
    })) || [];
    const subscriptionsWithDivider = (0, Table_1.createTableSections)({
        'admin.payments.subscriptions.active_subscription': activeSubscriptions,
        'admin.payments.subscriptions.expired_subscription': expiredSubscriptions
    }, 'subscription-section');
    const isLgOrLowerLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('lg'));
    const paymentsTableScroll = isLgOrLowerLayout ? { x: 1000 } : undefined;
    const columns = [
        {
            title: intl.formatMessage({ id: 'admin.payments.subscriptions.subscription_type' }),
            key: 'productId',
            align: 'center',
            render: (companyPaymentSubscription) => {
                if (companyPaymentSubscription.productId === types_1.ProductId.companyPremium) {
                    return ((0, jsx_runtime_1.jsx)(CustomTag, { color: "purple", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.subscriptions.company_premium_profile" }) }));
                }
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.subscriptions.start_date',
            }),
            key: 'startDate',
            dataIndex: 'startDate',
            align: 'center',
            render: (subscriptionStartDate) => {
                return (0, jsx_runtime_1.jsx)(FormattedDate_1.FormattedDate, { value: subscriptionStartDate, day: "numeric", month: "numeric", year: "numeric" });
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.subscriptions.end_date',
            }),
            key: 'endDate',
            dataIndex: 'endDate',
            align: 'center',
            render: (endDate) => {
                return (0, jsx_runtime_1.jsx)(FormattedDate_1.FormattedDate, { value: endDate, day: "numeric", month: "numeric", year: "numeric" });
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.subscriptions.period',
            }),
            key: 'subscriptionPeriod',
            dataIndex: 'endDate',
            align: 'center',
            render: (endDate, record) => {
                const isActive = (0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)([record]);
                if (isActive) {
                    const now = (0, dayjs_1.default)();
                    const endDateObj = (0, dayjs_1.default)(endDate);
                    const remainingDays = endDateObj.diff(now, 'day');
                    if (remainingDays > 0) {
                        return intl.formatMessage({
                            id: 'general.day.pluralized',
                        }, { count: remainingDays });
                    }
                }
                return '';
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.subscriptions.purchase_price_without_vat',
            }),
            key: 'purchasePrice',
            dataIndex: 'purchasePriceInCentsWithoutVat',
            align: 'center',
            render: (purchasePriceWithoutVat) => {
                const subscriptionPurchasePriceWithoutVat = purchasePriceWithoutVat / 100;
                if (!subscriptionPurchasePriceWithoutVat) {
                    return ((0, jsx_runtime_1.jsx)(CustomTag, { color: "green", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.free" }) }));
                }
                return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: subscriptionPurchasePriceWithoutVat, style: "currency", currency: "EUR" });
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.subscriptions.status.title',
            }),
            key: 'actions',
            fixed: isLgOrLowerLayout ? 'right' : undefined,
            align: 'center',
            width: isLgOrLowerLayout ? 220 : undefined,
            render: (companyPaymentSubscription) => {
                const isSubscriptionActive = (0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)([
                    companyPaymentSubscription,
                ]);
                const hasScheduledJobsToRun = companyPaymentSubscription.scheduledJobs.some(scheduledJob => !scheduledJob.deletedAt &&
                    !scheduledJob.triggerStartAt &&
                    types_1.ScheduledJobType.deactivateCompanyPremiumFeatures !== scheduledJob.jobType);
                const isFreeTrial = companyPaymentSubscription.purchasePriceInCentsWithoutVat === 0;
                const isActiveAndRescheduled = isSubscriptionActive && hasScheduledJobsToRun && !isFreeTrial;
                const isWaitingToExpire = isSubscriptionActive && !hasScheduledJobsToRun;
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isActiveAndRescheduled && ((0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: () => {
                                setSelectedSubscriptionIdToCancel(companyPaymentSubscription.id);
                            }, size: "middle", type: "default", danger: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.subscriptions.cancel_subscription" }) })), isWaitingToExpire && ((0, jsx_runtime_1.jsxs)(SubscriptionStatusTag, { color: "blue", children: [(0, jsx_runtime_1.jsx)(icons_1.ClockCircleOutlined, { className: "m-r-s" }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.subscriptions.waiting_to_expire" }) })] }))] }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Table, { enableSections: true, columns: columns, dataSource: subscriptionsWithDivider, scroll: paymentsTableScroll, pagination: false, rowKey: "id" }), (0, jsx_runtime_1.jsx)(CancelSubscriptionModal_1.default, { selectedSubscriptionIdToCancel: selectedSubscriptionIdToCancel, setSelectedSubscriptionIdToCancel: setSelectedSubscriptionIdToCancel })] }));
}
